import React from 'react'

import { AtsMessageTemplatesSelectorDocument } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import Select from 'modules/core/components/Select'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { messageTemplateVisibilityLabel } from 'modules/ats/lib/utils/messageTemplates'

interface Props {
  onMessageTemplateChanged: (messageTemplateContent: string, templateId: string) => void
  messageTemplateId?: string
}

export const MessageTemplatesSelector = ({
  onMessageTemplateChanged,
  messageTemplateId,
}: Props) => {
  const [selectedMessageTemplateId, setSelectedMessageTemplateId] = React.useState<
    string | undefined
  >(messageTemplateId)

  const { data, loading } = useQuery(AtsMessageTemplatesSelectorDocument)
  const messageTemplates = data?.ats.messageTemplatesConnection.nodes || []

  const onSelectTemplate = (id: string) => {
    const messageTemplateContent = messageTemplates.find((el) => el.id === +id)?.body || ''
    onMessageTemplateChanged(messageTemplateContent, id)
    setSelectedMessageTemplateId(id)
  }

  const orderedMessageTemplates = orderBy(
    messageTemplates,
    [
      (messageTemplate) => messageTemplate.visibility === 'company',
      (messageTemplate) => messageTemplate.name,
    ],
    ['desc', 'asc']
  )

  const options = orderedMessageTemplates.map((messageTemplate) => ({
    value: messageTemplate.id.toString(),
    label: `${messageTemplateVisibilityLabel(messageTemplate.visibility)} - ${
      messageTemplate.name
    }`,
  }))

  return (
    <Select
      none={i18n.t('ats.manage_message_templates.custom_message_option')}
      options={options}
      onChange={(value) => onSelectTemplate(value)}
      value={selectedMessageTemplateId}
      readonly={loading}
    />
  )
}
